if($('footer#footer').length){
    $('.copyright').html($('footer#footer .bootmMenu'))
    $('.footerContact .contact ul').append($('.contact-box li span.tel').closest('li'))
    $('.footerContact .contact ul').append($('.contact-box li span.mail').closest('li'))
    $('.footerContact .followUs ul').append($('.contact-box li span.facebook').closest('li'))
    $('.footerContact .followUs ul').append($('.contact-box li span.instagram').closest('li'))
    $('.footerContact .followUs ul').append($('.contact-box li span.youtube').closest('li'))
}
else{

}